<button class="c-botao text-truncate" [matTooltip]="nomesAcessorios" [disabled]="!nomesAcessorios"
  (click)="abrirModal()">{{nomesAcessorios || "Sem dados"}}</button>

<app-modal-general [showOrHideButton]="false" [showOrHideMessage]="false" #modal>
  <table class="c-table-container__table" mat-table [dataSource]="acessorios.registros">
    <ng-container matColumnDef="nomeMarcaProdutoSuprimento">
      <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
        <div class="u-border-none c-table-container__table__header-text">Marca</div>
      </th>
      <td class="c-table-container__table__cell" mat-cell *matCellDef="let acessorio">
        {{acessorio.nomeMarcaProdutoSuprimento
        || "Sem dados"}}</td>
    </ng-container>
    <ng-container matColumnDef="nomeProdutoSuprimento">
      <th class="u-padding-horizontal-0" mat-header-cell *matHeaderCellDef>
        <div class="u-border-none c-table-container__table__header-text">Descrição</div>
      </th>
      <td class="c-table-container__table__cell" mat-cell *matCellDef="let acessorio">
        {{acessorio.nomeProdutoSuprimento
        || "Sem dados"}}</td>
    </ng-container>
    <tr class="c-table-container__table__header-row" mat-header-row *matHeaderRowDef="colunasVisiveis; sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: colunasVisiveis;"></tr>
  </table>
</app-modal-general>